import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import apis from '@/apis/evidenceListApi';
import EvidenceList from './EvidenceList.vue';
import EvidenceImage from './EvidenceImage.vue';
var timer = null;

var EvidenceInfo = /*#__PURE__*/function (_Vue) {
  _inherits(EvidenceInfo, _Vue);

  var _super = _createSuper(EvidenceInfo);

  function EvidenceInfo() {
    var _this;

    _classCallCheck(this, EvidenceInfo);

    _this = _super.call(this);
    _this.caseStatus = '';
    _this.trials = [];
    _this.fileUrl = '';
    _this.fileType = '';
    return _this;
  }

  _createClass(EvidenceInfo, [{
    key: "getImageUrl",
    value: function getImageUrl(url, type) {
      // console.log('get image url 2')
      this.fileUrl = url || '';
      this.fileType = type || '';
    }
  }, {
    key: "getFiles",
    value: function getFiles(type) {
      var _this2 = this;

      var param = {
        caseId: this.caseId ? this.caseId : ''
      };
      apis.getFiles(param).then(function (res) {
        _this2.trials = res.data;
      }).catch(function (_) {});
    }
  }, {
    key: "getCaseDetail",
    value: function getCaseDetail() {
      var _this3 = this;

      var param = {
        caseIndexCode: this.caseId ? this.caseId : ''
      };
      apis.caseDetail(param).then(function (res) {
        _this3.caseStatus = res.data.status;
      }).catch(function (_) {});
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getFiles();
      this.getCaseDetail();
    }
  }]);

  return EvidenceInfo;
}(Vue);

__decorate([Prop({
  type: String,
  required: true
})], EvidenceInfo.prototype, "caseId", void 0);

EvidenceInfo = __decorate([Component({
  components: {
    EvidenceList: EvidenceList,
    EvidenceImage: EvidenceImage
  }
})], EvidenceInfo);
export default EvidenceInfo;